import capitalizeString from '@functions/utils/capitalizeString'

function camelCaseToTitleCase(string: string) {
  if (!string || typeof string !== 'string') return ''

  return capitalizeString(string.replace(/([A-Z]+)/g, ' $1'))
}

export default camelCaseToTitleCase